export const STRUCTURE_SHOW_RESET = "STRUCTURE_SHOW_RESET";
export const STRUCTURE_SHOW_SET_ERROR = "STRUCTURE_SHOW_SET_ERROR";
export const STRUCTURE_SHOW_SET_RETRIEVED = "STRUCTURE_SHOW_SET_RETRIEVED";
export const STRUCTURE_SHOW_TOGGLE_LOADING = "STRUCTURE_SHOW_TOGGLE_LOADING";
